var map = {
	"./background-photo.png": "e67e",
	"./certificate.svg": "e3a3",
	"./clip.svg": "7fe5",
	"./close-2.svg": "1882",
	"./close-mobile.svg": "4435",
	"./close.svg": "1d1b",
	"./down-arrow.svg": "9367",
	"./download-arrow.png": "6cf9",
	"./fast-delivery.svg": "818e",
	"./file-icon.svg": "868c",
	"./gallery-1.jpg": "9428",
	"./gallery-2.jpg": "fd17",
	"./gallery-3.jpg": "0fe9",
	"./gallery-4.jpg": "fc5d",
	"./geolocation.svg": "6ccf",
	"./inside-factory-1.jpg": "6361",
	"./inside-factory-2.jpg": "39e0",
	"./inst.svg": "cc17",
	"./item-excavator.svg": "c1bb",
	"./item-factory.svg": "caf7",
	"./item-file.svg": "2346",
	"./item-lathe.svg": "a7a5",
	"./item-sb.svg": "7de4",
	"./item-welding.svg": "326a",
	"./location.svg": "e496",
	"./logo.png": "4ffd",
	"./map-icon.svg": "b3ca",
	"./menu.svg": "869f",
	"./partner-1.svg": "a6c4",
	"./partner-10.svg": "1af0",
	"./partner-2.svg": "7ccb",
	"./partner-3.svg": "f313",
	"./partner-4.svg": "af0c",
	"./partner-5.svg": "ec7d",
	"./partner-6.svg": "2972",
	"./partner-7.svg": "4fd9",
	"./partner-8.svg": "fec9",
	"./partner-9.svg": "ec4b",
	"./pay.svg": "714f",
	"./photo-car.png": "8964",
	"./pickup-face-truck.svg": "a192",
	"./quality.svg": "9fdf",
	"./rocket.svg": "1929",
	"./show-on-map.svg": "79bf",
	"./stopwatch.svg": "62cf",
	"./ten-years.svg": "3eae",
	"./traktor.jpg": "09f5",
	"./truck.svg": "d39e",
	"./yellow-babina.png": "8067",
	"./zavod-2.jpg": "3613",
	"./zavod-blue.jpg": "0851",
	"./zavodik.jpg": "c24e",
	"./zoom-minus.svg": "2966",
	"./zoom-plus.svg": "0ee2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";